import React from "react";
import { survivalGroupDisplay } from "../ReusableComponent/survivalGroupDisplay";

export default function KaplanMeierChart({ plot, containerRef, dataType }) {
  const curves = plot.curves.filter((curve) => Array.isArray(curve.points) && curve.points.length);
  const maxTime = Math.max(1, ...curves.flatMap((curve) => curve.points.map((point) => point.time)));
  const x = (time) => 58 + time / maxTime * 342;
  const y = (survival) => 242 - survival * 218;

  return <div ref={containerRef} style={{ padding: "8px" }}>
    <svg viewBox={`0 0 430 ${310 + curves.length * 18}`} role="img" aria-label={plot.title || "Kaplan–Meier overall survival"}
      style={{ display: "block", width: "100%", height: "auto" }} fontFamily="Arial, sans-serif" fontSize="10" fill="#747987">
      <title>{plot.title || "Kaplan–Meier overall survival"}</title>
      {[0, 0.25, 0.5, 0.75, 1].map((tick) => <g key={tick}>
        <path d={`M58 ${y(tick)} H400 M${x(tick * maxTime)} 24 V242`} stroke="#e6e8ef" strokeDasharray="3 3" fill="none" />
        <text x="50" y={y(tick) + 3} textAnchor="end">{tick.toFixed(2)}</text>
        <text x={x(tick * maxTime)} y="260" textAnchor="middle">{Number((tick * maxTime).toFixed(1))}</text>
      </g>)}
      <path d="M58 24 V242 H400" fill="none" stroke="#a3a6b0" />
      <text x="229" y="284" textAnchor="middle">{plot.x_axis?.label || "Time (Days)"}</text>
      <text transform="translate(16 133) rotate(-90)" textAnchor="middle">{plot.y_axis?.label || "Survival Probability"}</text>
      {curves.map((curve, index) => {
        const { label, color } = survivalGroupDisplay(dataType, curve.group, index);
        const points = [...curve.points].sort((a, b) => a.time - b.time);
        const path = points.map((point, i) => i === 0 ? `M${x(point.time)} ${y(point.survival)}` : `H${x(point.time)} V${y(point.survival)}`).join(" ");
        return <g key={`${curve.group}-${index}`}>
          <path className="km-survival-curve" d={path} fill="none" stroke={color} strokeWidth="2" />
          {(curve.censor_marks || []).map((mark, i) => <path key={i} className="km-censor-mark"
            d={`M${x(mark.time)} ${y(mark.survival) - 3} v6`} stroke={color} strokeWidth="1.5">
            <title>{`${label}: ${mark.time} days, survival ${mark.survival.toFixed(4)}, censored ${mark.count}`}</title>
          </path>)}
          <path d={`M80 ${306 + index * 18} h18`} stroke={color} strokeWidth="2" />
          <text x="104" y={310 + index * 18} fill={color}>{label} (n = {curve.sample_count ?? "—"})</text>
        </g>;
      })}
    </svg>
  </div>;
}
